import MultichoiceImageDisplay from './MultichoiceImageDisplay';

export default MultichoiceImageDisplay;
